<ion-content>
  <ion-row class="ion-justify-content-center">
    <ion-col size-xl="4" size-lg="6" size-md="8" size-sm>
      <ion-card>
        <div class="logo-container">
          <img src="./assets/images/login_logo_white.png" />
        </div>
        <form *ngIf="!resetSent" [formGroup]="passwordResetForm">
          <ion-label>Forgot your password?</ion-label>
          <p class="info" style="text-align: center">
            No worries, we can reset it for you in a jiffy.<br/><br/>
            <b>Just enter your email below and click the button:</b>
          </p>
          <ion-input
            type="email"
            name="email"
            formControlName="email"
            (ionFocus)="emailFocus()"
            (keyup.enter)="sendEmail()"
          ></ion-input>
          <ion-button
            color="light"
            [disabled]="this.email.invalid"
            expand="block"
            tappable
            (click)="sendEmail()"
          >
          Send a reset link to your email
          </ion-button>
        </form>
        <div *ngIf="resetSent">
          <ion-label>Please check your email</ion-label>
          <p class="info">We have sent an email to <b>{{email.value}}</b> allow you to reset your password.</p>
        </div>
        <ion-button
          class="back-btn"
          expand="block"
          fill="clear"
          routerLink="/login"
          tappable
        >
        ← Back
        </ion-button>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-content>
